import { render, staticRenderFns } from "./message-file.vue?vue&type=template&id=cfeb53bc&scoped=true"
import script from "./message-file.vue?vue&type=script&lang=ts"
export * from "./message-file.vue?vue&type=script&lang=ts"
import style0 from "./message-file.vue?vue&type=style&index=0&id=cfeb53bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfeb53bc",
  null
  
)

export default component.exports